import { render, staticRenderFns } from "./ModalChangeName.vue?vue&type=template&id=26b4453e&scoped=true"
import script from "./ModalChangeName.vue?vue&type=script&lang=js"
export * from "./ModalChangeName.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeName.vue?vue&type=style&index=0&id=26b4453e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b4453e",
  null
  
)

export default component.exports